import { render, staticRenderFns } from "./EditEntityCard.vue?vue&type=template&id=e9b22fb8&"
import script from "./EditEntityCard.vue?vue&type=script&lang=js&"
export * from "./EditEntityCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports